<template>
  <modal v-if="modalResultSurvey.active" @close="closeModalResults"> 
    <template slot="header">
      <h4 class="modal-title">{{$t('games.survey.results.title')}}</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeModalResults">
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <md-progress-bar md-mode="query" class="md-accent" v-if="loadingResults"></md-progress-bar>
      <md-table v-else>
        <md-table-row>
          <md-table-head>{{$t('games.survey.results.question')}}</md-table-head>
          <md-table-head>{{$t('games.survey.results.response1')}}</md-table-head>
          <md-table-head>{{$t('games.survey.results.response2')}}</md-table-head>
          <md-table-head>{{$t('games.survey.results.response3')}}</md-table-head>
          <md-table-head>{{$t('games.survey.results.response4')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="(survey, idxSurvey) in surveyFinished" :key="idxSurvey">
          <md-table-cell>
            <div>
              {{survey.questionText}}
              <md-tooltip md-direction="bottom">
                {{$t('survey.create.startDate')}}<br> 
                <strong>{{dateFormat(survey.startDate)}}</strong> <br>
                {{$t('survey.create.durationSeconds')}}<br>
                <strong>{{survey.durationSeconds}}</strong> <br>
                <span v-if="survey.code != null">
                  {{$t('survey.create.code')}} <br>
                  <strong>{{survey.code}}</strong>  
                </span>
              </md-tooltip>
            </div>
          </md-table-cell>
          <md-table-cell><strong>{{survey.answerText01}} {{survey.answerValue01}}%</strong> </md-table-cell>
          <md-table-cell><strong>{{survey.answerText02}} {{survey.answerValue02}}%</strong> </md-table-cell>
          <md-table-cell><strong>{{survey.answerText03}} {{survey.answerValue03}}%</strong> </md-table-cell>
          <md-table-cell><strong v-if="survey.answerValue04 != null">{{survey.answerText04}} {{survey.answerValue04}}%</strong> </md-table-cell>
        </md-table-row>
      </md-table>
    </template>
  </modal>
</template>

<script>
import { Modal } from '@/components'
import { mapState } from 'vuex'

export default {
  components: {
    Modal
  },
  data () {
    return {
      surveyFinished: [],
      loadingResults: false
    }
  },
  computed: {
    ...mapState({
      modalResultSurvey: state => state.ModalModule.modalResultSurvey
    })
  },
  methods: {
    closeModalResults() {
      this.$store.dispatch("closeModalResultSurvey")
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  },
  watch: {
    'modalResultSurvey': async function(resultSurvey) {
      if (resultSurvey.active) {
        document.getElementsByClassName("wrapper")[0].style.overflow = "hidden"
        document.getElementsByClassName("wrapper")[0].style.height = "auto"
        document.getElementsByClassName("wrapper")[0].style.position = "fixed"
        this.loadingResults = true
      } else {
        document.getElementsByClassName("wrapper")[0].style.overflow = "initial"
        document.getElementsByClassName("wrapper")[0].style.height = "100vh"
        document.getElementsByClassName("wrapper")[0].style.position = "initial"
        this.loadingResults = false
      }

      const request = await this.$store.dispatch("getFinished", {
        gameId: resultSurvey.gameId,
        teamId: resultSurvey.teamId
      })
      if (request.status == 200) {
        this.surveyFinished = request.data,
        this.loadingResults = false
      }
    }
  }
}
</script>

<style>

.modal-mask .md-table-content {
  max-height: 360px;
}

</style>